import { Injectable } from '@angular/core';
import { HttpService } from './helpers/http.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ErrorService } from './helpers/error.service';

import { Operation } from '../models/models';

@Injectable({
  providedIn: 'root'
})
export class SystemPointsLogService {

  constructor(
    private httpService: HttpService,
    private errorService: ErrorService) {

  }

  getAll(userId: number, skip: number, take: number): Observable<Operation[]> {
    return this.httpService.sendGet(`system-points-log/get-all?skip=${skip}&take=${take}&userId=${userId}`)
      .pipe(map(response => {
        return this.errorService.processResponseForErrors(response);
      }));
  }

  getCount(userId: number): Observable<number> {
    return this.httpService.sendGet('system-points-log/get-count?userId=' + userId)
      .pipe(map(response => {
        return this.errorService.processResponseForErrors(response);
      }));
  }
}
